import Box from "@mui/joy/Box";
import SelectRibbonLenght from "./SelectRibbonLenght";
import SelectRibbonWidth from "./SelectRibbonWidth";
import SelectFontColor from "./SelectFontColors";
import AddTextandAttr from "./AddTextandAttr";
import SelectIcon from "./SelectIcons";
import InputFileUpload from "./UploadFile";
import UserExtraOptions from "./UserExtraOtions";
import ColorsCheckbox from "./RibbonColorCheckBoxes";
import NotifyUserAboutPreview from "./InfoAboutRibbonView";



export default function BoxForOptions() {
   
  
    return(
        <Box sx={{
            width: "100%",
            // border: "2px solid blue"
        }}>
        
        <Box
            
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: {md: "space-around", sm: "space-around", xs: 'space-around',},
                gap: 2,
                paddingBottom: 5,
        }}
        >
        
            <ColorsCheckbox />
            <SelectRibbonLenght/>
            <SelectRibbonWidth/>
            <SelectFontColor/>
            <SelectIcon/>
            
           
            
        </Box>
        <InputFileUpload/>
        <AddTextandAttr/>
        <NotifyUserAboutPreview/>
        <UserExtraOptions/>
        </Box>
        
    )
}